import { data } from '../../svg/Connection/data';
import { makeIcon } from '../makeIcon';

export const Connection = makeIcon(data, 'connection', 'Connection');

export default Connection;
